import React from "react"
import { ResponsiveBar } from "@nivo/bar"
import ChartCard from "./ChartCard"
import { PALETTE, formatShort, NIVO_THEME } from "./palette"

// Monthly issued quotes (count + HT) over the selected period.
const QuotesIssuedChart = ({ data }) => {
  const rows  = data || []
  const total = rows.reduce((acc, d) => acc + (d.value || 0), 0)
  const count = rows.reduce((acc, d) => acc + (d.count || 0), 0)
  const subtitle = total > 0
    ? I18n.t("chantiers_dashboard.charts.quotes_issued_hint", { count: count, amount: formatShort(total) })
    : null

  return (
    <ChartCard
      icon     = "file-circle-plus"
      title    = {I18n.t("chantiers_dashboard.charts.quotes_issued")}
      subtitle = {subtitle}
      height   = {320}
      empty    = {total === 0 ? I18n.t("chantiers_dashboard.charts.empty") : null}
    >
      <ResponsiveBar
        data         = {rows}
        keys         = {["value"]}
        indexBy      = "label"
        margin       = {{ top: 18, right: 28, bottom: 54, left: 72 }}
        padding      = {0.32}
        colors       = {[PALETTE.fuchsia]}
        borderRadius = {3}
        enableLabel  = {false}
        axisBottom   = {{ tickRotation: -30, tickSize: 4, tickPadding: 6 }}
        axisLeft     = {{ tickValues: 5, format: (v) => formatShort(v) }}
        gridYValues  = {5}
        tooltip      = {({ value, indexValue, data: d }) => (
          <div style={{ background: "#0f172a", color: "#fff", padding: "6px 10px", fontSize: 11, borderRadius: 6, boxShadow: "0 8px 20px rgba(15,23,42,0.25)" }}>
            <div style={{ fontWeight: 600, marginBottom: 2 }}>{indexValue}</div>
            <div>{formatShort(value)}</div>
            <div style={{ opacity: 0.7 }}>{d.count} {I18n.t("chantiers_dashboard.charts.quotes_count_label", { count: d.count })}</div>
          </div>
        )}
        theme        = {NIVO_THEME}
      />
    </ChartCard>
  )
}

export default QuotesIssuedChart
